import { render } from "./HealthTestDontMessageModal.vue?vue&type=template&id=93a1244a&scoped=true"
import script from "./HealthTestDontMessageModal.vue?vue&type=script&lang=js"
export * from "./HealthTestDontMessageModal.vue?vue&type=script&lang=js"

import "./HealthTestDontMessageModal.vue?vue&type=style&index=0&id=93a1244a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a1244a"]])

export default __exports__